import { SVGProps } from 'react';

export const IconArrow = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='2 2 20 20'>
      <path
        d='M18.5303 12.5303C18.8232 12.2374 18.8232 11.7626 18.5303 11.4697L13.7574 6.6967C13.4645 6.40381 12.9896 6.40381 12.6967 6.6967C12.4038 6.98959 12.4038 7.46447 12.6967 7.75736L16.9393 12L12.6967 16.2426C12.4038 16.5355 12.4038 17.0104 12.6967 17.3033C12.9896 17.5962 13.4645 17.5962 13.7574 17.3033L18.5303 12.5303ZM6 11.25C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75V11.25ZM18 11.25H6V12.75H18V11.25Z'
        fill='currentColor'
      />
    </svg>
  );
};
